import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import TitleSectionComponent from "../../Components/TitleSectionComponent/TitleSectionComponent";
import { MdOutlineArticle } from "react-icons/md";
import ArticleSliderItem from "../../Components/ArticleSliderItem/ArticleSliderItem";
import "./ArticleCategory.css";
import { axiosConfig } from "../../Configuration/axios/axiosConfiguration";
import PaginationComponent from "../../Components/PaginationComponent/PaginationComponent";
import { Helmet } from "react-helmet-async";


export default function ArticleCategory() {
    const [blog, setBlog] = useState([]);
    const [blogCount, setBlogCount] = useState(0);
    const [page, setPage] = useState(1);
    const [orderType, setOrderType] = useState();

    useEffect(() => {
        setPage(1);
        setOrderType("RegisterDate");
    }, []);

    useEffect(() => {
        if (orderType === undefined) return;
        getBlogs();
    }, [page, orderType]);

    const getBlogs = () => {
        axiosConfig
            .get(`api/blog?page=${page}&pageSize=24&orderBy=${orderType}`)
            .then((result) => {
                setBlog(result.data.data);
                setBlogCount(result.data.count);
            })
            .catch((err) => {
            });
    };

    return (
        <>
            <Helmet>
                <title>مقالات علمی و صنعتی به‌روز | بانک دانش سه‌نیک</title>
                <meta
                    name="description"
                    content="دسترسی به جدیدترین مقالات علمی، صنعتی و آموزشی در حوزه مدیریت تولید، کسب‌وکار، صنایع خانگی و فناوری‌های روز. محتوای کاملاً به‌روز و رایگان در پلتفرم آموزشی سه‌نیک."
                />
            </Helmet>
            <div className="article-category">
                <Container>
                    <div className="article-category-header">
                        <TitleSectionComponent
                            title="تمام مقالات"
                            icon={<MdOutlineArticle />}
                        />
                        <select onChange={(e) => setOrderType(e.target.value)}>
                            <option value="RegisterDate">
                                مرتب سازی بر اساس تاریخ
                            </option>
                            <option value="View">
                                مرتب سازی بر اساس بازدید
                            </option>
                        </select>
                    </div>
                    <div className="article-category-items">
                        <Row>
                            {blog.map((item) => (
                                <Col lg={3} key={item.id}>
                                    <div className="article-category-item">
                                        <ArticleSliderItem item={item} />
                                    </div>
                                </Col>
                            ))}
                        </Row>
                        <div className="d-flex justify-content-center mt-5 ltr">
                            <PaginationComponent
                                itemsCount={blogCount}
                                itemsPerPage={24}
                                currentPage={page}
                                setCurrentPage={setPage}
                                alwaysShown={true}
                            />
                        </div>
                    </div>
                </Container>
            </div>
        </>
    );
}
